/**
 * Tela ainda não entregue (marca o lugar dela na navegação) — Nexora Grid (frontend).
 *
 * Criado em: 16/10/2026 · Última modificação: 16/10/2026 · Versão: 1.0.0
 */
export function EmConstrucao({ titulo, historia }: { titulo: string; historia: string }) {
  return (
    <section className="nx-cartao em-construcao">
      <h2 className="nx-titulo">{titulo}</h2>
      <p className="nx-suave">Em construção ({historia}).</p>
    </section>
  );
}
